import { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';
import { BsSearch } from 'react-icons/bs';

import TextInput from '#globalComponents/Forms/TextInput';
import { useDebouncedValue } from '#globalHooks/useDebouncedValue';

/**
 * Free-text table filter: keeps a local draft so typing never thrashes the URL, and commits it
 * debounced. External changes (chip removed, filters cleared) reset the draft.
 */
const TableSearchInput = ({ value = '', onChange, placeholder = 'Suchen …', className = '' }) => {
	const [draft, setDraft] = useState(value);
	const debounced = useDebouncedValue(draft, 300);
	const committedRef = useRef(value);

	useEffect(() => {
		if (value !== committedRef.current) {
			committedRef.current = value;
			setDraft(value);
		}
	}, [value]);

	useEffect(() => {
		if (debounced.trim() === committedRef.current) return;
		committedRef.current = debounced.trim();
		onChange(debounced.trim() || undefined);
	}, [debounced, onChange]);

	return (
		<div className={`relative ${className}`}>
			<BsSearch className="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-bgBase-800" />
			<TextInput
				type="search"
				value={draft}
				onChange={(event) => setDraft(event.target.value)}
				placeholder={placeholder}
				className="pl-9"
				aria-label={placeholder}
			/>
		</div>
	);
};

TableSearchInput.propTypes = {
	value: PropTypes.string,
	/** Receives the trimmed term, or undefined when cleared. */
	onChange: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
	className: PropTypes.string,
};

export default TableSearchInput;
